import { useEventListener } from "@chakra-ui/react";
import React from "react";
import MultiRef from "react-multi-ref";

export interface SearchItem {
  label: string;
  value: string;
}
export function useSearch(
  customFetcher: (input: string) => Promise<SearchItem[]>,
  onSubmit: (result: SearchItem) => void,
) {
  const [menuNodes] = React.useState(() => new MultiRef<number, HTMLElement>());

  const eventRef = React.useRef<"mouse" | "keyboard">(null);
  const [input, setInput] = React.useState("");
  const [selectedItem, setSelectedItem] = React.useState<number>(0);
  const [items, setItems] = React.useState<any[]>([]);
  const fetchNewResult = async () => {
    setInput(input);
    if (input.length < 1) {
      setItems([]);
      return;
    }
    const res = await customFetcher(input);
    setItems(res);
  };

  const handleSelection = (idx: number) => {
    setSelectedItem(idx);
    onSubmit(items[idx]);
  };
  React.useEffect(() => {
    async function fetchItems() {
      await fetchNewResult();
    }
    fetchItems();

    return () => {
      setInput("");
      setItems([]);
    };
  }, [input]);
  useEventListener("keydown", (event) => {
    const isMac = /(Mac|iPhone|iPod|iPad)/i.test(navigator?.platform);
    const hotkey = isMac ? "metaKey" : "ctrlKey";
    if (event?.key?.toLowerCase() === "k" && event[hotkey]) {
      event.preventDefault();
      setInput("");
    }
  });

  const onKeyDown = React.useCallback(
    (e: any) => {
      // @ts-ignore
      eventRef.current = "keyboard";
      switch (e.key) {
        case "ArrowDown": {
          e.preventDefault();
          if (selectedItem + 1 < items.length) {
            setSelectedItem(selectedItem + 1);
          }
          break;
        }
        case "ArrowUp": {
          e.preventDefault();
          if (selectedItem - 1 >= 0) {
            setSelectedItem(selectedItem - 1);
          }
          break;
        }
        case "Enter": {
          if (selectedItem && items?.[selectedItem]) {
            onSubmit(items[selectedItem]);
          } else {
            onSubmit(items[0]);
          }

          break;
        }
      }
    },
    [items, selectedItem, onSubmit],
  );

  return {
    items,
    input,
    onKeyDown,
    eventRef,
    menuNodes,
    selectedItem,
    setSelectedItem,
    handleSelection,
    setInput,
  };
}
